export const DEFAULT_DEALS_COUNT = 12;
